import { render, staticRenderFns } from "./Onboarding.vue?vue&type=template&id=29e44c50"
import script from "./Onboarding.vue?vue&type=script&lang=js"
export * from "./Onboarding.vue?vue&type=script&lang=js"
import style0 from "./Onboarding.vue?vue&type=style&index=0&id=29e44c50&prod&lang=scss"
import style1 from "./Onboarding.vue?vue&type=style&index=1&id=29e44c50&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports